import { render, staticRenderFns } from "./NoRoles.vue?vue&type=template&id=affcd4e4"
import script from "./NoRoles.vue?vue&type=script&lang=ts"
export * from "./NoRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports